import React from 'react'
import { Match } from '@reach/router'

export default path => Component => props =>
  <Match path={path} >
    {({ match }) => <Component {...{ ...props, match }} />}
  </Match>
